module.exports = __webpack_public_path__ + "img/电梯动画20.b0508cb8.png";